import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

const COLS = [
  { key: "scheduled", label: "Scheduled", bg: "bg-[#E0F2FE]", accent: "border-[#0284C7]" },
  { key: "in_progress", label: "In Progress", bg: "bg-[#FEF3C7]", accent: "border-[#D97706]" },
  { key: "completed", label: "Completed", bg: "bg-[#D1FAE5]", accent: "border-[#059669]" },
];

export default function JobBoard() {
  const [items, setItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [inspector, setInspector] = useState("all");

  useEffect(() => { (async () => {
    const [i, u] = await Promise.all([api.get("/inspections"), api.get("/users")]);
    setItems(i.data); setUsers(u.data);
  })(); }, []);

  const filtered = inspector === "all" ? items : items.filter(i => i.inspector_id === inspector || (inspector === "unassigned" && !i.inspector_id));
  const byStatus = (s) => filtered.filter(i => i.status === s);

  return (
    <div className="p-6 md:p-8" data-testid="board-page">
      <div className="flex items-start justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-1">Workload</div>
          <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Job Board</h1>
        </div>
        <select data-testid="inspector-filter" value={inspector} onChange={(e) => setInspector(e.target.value)} className="rounded-md border border-gray-300 px-3 py-2 text-sm bg-white">
          <option value="all">All inspectors</option>
          <option value="unassigned">Unassigned</option>
          {users.filter(u => u.role !== 'viewer').map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {COLS.map(col => (
          <div key={col.key} className="bg-white border border-gray-200" data-testid={`col-${col.key}`}>
            <div className={`px-4 py-3 border-b border-gray-200 ${col.bg} border-l-4 ${col.accent}`}>
              <div className="flex items-center justify-between">
                <h2 className="font-display text-sm font-bold tracking-tight uppercase">{col.label}</h2>
                <span className="font-mono text-xs font-bold">{byStatus(col.key).length}</span>
              </div>
            </div>
            <div className="p-3 space-y-2 min-h-[400px]">
              {byStatus(col.key).length === 0 ? <div className="text-xs text-gray-400 text-center py-6">Empty</div>
                : byStatus(col.key).map(i => (
                <Link key={i.id} to={`/inspections/${i.id}`} className="block bg-gray-50 border border-gray-200 p-3 hover:border-[#01ADEF]" data-testid={`board-card-${i.id}`}>
                  <div className="font-semibold text-sm">{i.asset_name}</div>
                  <div className="text-xs text-gray-500 font-mono">{i.asset_tag}</div>
                  <div className="flex items-center justify-between mt-2 text-xs">
                    <span className="capitalize text-gray-600">{i.inspection_type?.replace('_',' ')}</span>
                    <span className="font-mono">{i.scheduled_date?.slice(0,10)}</span>
                  </div>
                  <div className="text-xs mt-1 text-gray-500">{i.inspector_name || <em>Unassigned</em>}</div>
                  {i.result && <span className={`inline-block mt-2 text-xs font-bold px-2 py-0.5 uppercase border ${i.result === 'pass' ? 'bg-[#D1FAE5] text-[#065F46] border-[#6EE7B7]' : 'bg-[#FEE2E2] text-[#B91C1C] border-[#FCA5A5]'}`}>{i.result}</span>}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
